<template>
  <div>
    <div v-if="$route.name !== 'Login'" style="min-height: 60px">
      <top-nav />
    </div>
    <v-row>
      <!--<v-col v-if="$route.name !== 'Login'" class="side_nav" sm="2">
        <side-nav />
      </v-col>-->
      <v-col :class="{ 'col-sm-12': $route.name !== 'Login' }"
        ><router-view
      /></v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import topNav from '@/components/header/top-nav.vue';
import sideNav from '@/components/SideNav/SideNav.vue';
import '@/assets/scss/styles.scss';
export default {
  components: {
    topNav,
    sideNav,
  },
  created() {},
  methods: {
    ...mapActions({
      userLogin: 'user/loginAction',
    }),
  },
};
</script>
